import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VerificationBankRoutingModule } from './verification-bank-routing.module';
import { VerificationBankComponent } from './verification-bank.component';
import { VerificationBankCardComponent } from './verification-bank-card/verification-bank-card.component';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { VerificationBankDetailComponent } from './verification-bank-detail/verification-bank-detail.component';
import { SharedModule } from '@shared/shared.module';
import {MatGridListModule} from '@angular/material/grid-list';





@NgModule({
  declarations: [VerificationBankComponent, VerificationBankCardComponent, VerificationBankDetailComponent],
  imports: [
    CommonModule,
    VerificationBankRoutingModule,
    MatCardModule,
    MatIconModule,
    MatDatepickerModule,
    SharedModule,
    MatGridListModule,
  ],
  
})
export class VerificationBankModule { }
